"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var Checkbox_1 = __importDefault(require("../../Checkbox"));
var DataContext_1 = require("../DataContext");
function Row(_a) {
    var id = _a.id, children = _a.children, onClick = _a.onClick, _b = _a.align, align = _b === void 0 ? "flex-start" : _b;
    var _c = DataContext_1.useDataContext(), skeleton = _c.skeleton, bulkAction = _c.bulkAction, selectedRowsId = _c.selectedRowsId, onSelectRow = _c.onSelectRow;
    var active = selectedRowsId === null || selectedRowsId === void 0 ? void 0 : selectedRowsId.includes(id);
    var classNameRow = classnames_1.default("nimbus--data-table__row", {
        "nimbus--data-table__row--active": active,
    });
    var classNameRowCheck = classnames_1.default("nimbus--data-table__cell-checkbox is--visible");
    var handleClick = function (event) {
        event.stopPropagation();
        onClick === null || onClick === void 0 ? void 0 : onClick(id);
    };
    var handleChange = function () {
        onSelectRow === null || onSelectRow === void 0 ? void 0 : onSelectRow(id);
    };
    return (React.createElement("div", { onClick: handleClick, className: classNameRow, style: { alignItems: align } },
        onSelectRow && bulkAction && (React.createElement("div", { className: classNameRowCheck }, skeleton ? (React.createElement(Checkbox_1.default, { name: id, disabled: true })) : (React.createElement(Checkbox_1.default, { name: id, checked: active, onChange: handleChange })))),
        children));
}
exports.default = Row;
//# sourceMappingURL=Row.js.map